import { Button } from "web-design-system";
import { usePortfolioReviewOverview } from "creso-core/hooks";
import { Page } from "@core/components/layout/page";
import { PortfolioJourney } from "./portfolio-journey";
import { PoorlyPerformingFunds } from "./poorly-performing-funds";
import { ExposureSection } from "./exposure-section";
import { ExternalHoldingsSection } from "./external-holdings-section";
import { PastReviews } from "./past-reviews";
import { StartReviewMenu } from "./start-review-menu";

export function PortfolioReviewLanding({
  clientId,
  investmentAccountId,
}: {
  clientId: number;
  investmentAccountId: string;
}) {
  const { data: overview, isLoading } = usePortfolioReviewOverview({
    investment_account_guid: investmentAccountId,
  });

  return (
    <>
      <Page.Header
        title="Portfolio Review"
        actions={
          <>
            <Button variant="outline">Generate Review</Button>
            <StartReviewMenu
              clientId={clientId}
              investmentAccountId={investmentAccountId}
            />
          </>
        }
      />
      <Page.Body className="flex flex-col gap-10 pb-8">
        <div className="flex flex-col gap-6">
          <PortfolioJourney investmentAccountId={investmentAccountId} />
          <PoorlyPerformingFunds
            investmentAccountId={investmentAccountId}
            overviewBlock={overview?.poorly_performing}
            isOverviewLoading={isLoading}
          />
          <ExposureSection block={overview?.exposure} isLoading={isLoading} />
          <ExternalHoldingsSection
            block={overview?.external_holdings}
            isLoading={isLoading}
          />
        </div>
        <PastReviews clientId={clientId} />
      </Page.Body>
    </>
  );
}
